import React from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {accessConstants, authUtils} from "mindsets-js-sdk";

const EditMenuItem = function ({id}) {
    const me = useSelector(state => state.me);
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_ALL_LESSONS])) {
        return (
            <Link to={'/lessons/' + id} className="button mx-2 my-1">Edit</Link>
        );
    }

    return null;
}

EditMenuItem.propTypes = {
    id: PropTypes.number.isRequired
}

export default EditMenuItem;
